import script from "./QuasarFileUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuasarFileUploader.vue?vue&type=script&setup=true&lang=ts"

import "./QuasarFileUploader.vue?vue&type=style&index=0&id=0f464176&lang=scss"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QUploaderAddTrigger from 'quasar/src/components/uploader/QUploaderAddTrigger.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QUploader,QSpinner,QIcon,QTooltip,QBtn,QUploaderAddTrigger,QImg});
